(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[521],{

/***/ 9212:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about",
      function () {
        return __webpack_require__(5303);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ AboutPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/tinacms/dist/react.mjs
var react = __webpack_require__(6945);
// EXTERNAL MODULE: ./node_modules/tinacms/dist/rich-text/index.mjs
var rich_text = __webpack_require__(4626);
// EXTERNAL MODULE: ./components/Box.tsx
var Box = __webpack_require__(4285);
// EXTERNAL MODULE: ./components/layout/Layout.tsx + 3 modules
var Layout = __webpack_require__(7487);
// EXTERNAL MODULE: ./src/getUrls.ts
var getUrls = __webpack_require__(3916);
;// CONCATENATED MODULE: ./components/layout/head/getAboutPageJsonLd.ts

function getAboutPageJsonLd(param) {
    var locale = param.locale;
    return {
        "@type": "AboutPage",
        "@id": "".concat((0,getUrls/* getBlogUrl */.Z)({
            locale: locale
        }), "/about"),
        url: "".concat((0,getUrls/* getBlogUrl */.Z)({
            locale: locale
        }), "/about")
    };
}

// EXTERNAL MODULE: ./src/translations.tsx + 2 modules
var translations = __webpack_require__(171);
;// CONCATENATED MODULE: ./pages/about.tsx








var __N_SSG = true;
/* eslint-enable prettier/prettier */ function AboutPage(props) {
    var data = (0,react/* useTina */.UL)({
        query: props.query,
        variables: {},
        data: props.data
    }).data;
    var page = data.page.body;
    var _page = data.page, title = _page.title, description = _page.description;
    var t = (0,translations/* useT */.N)();
    var locale = (0,router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* Layout */.A, {
        title: title,
        description: description,
        jsonLd: getAboutPageJsonLd({
            locale: locale
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* BoxSection */.js, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(rich_text/* TinaMarkdown */.t, {
                        content: page
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* BoxSection */.js, {
                    children: [
                        t.pages.about.moreInfo1,
                        t.pages.about.moreInfo2
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 3916:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ getBlogPostingUrl; },
/* harmony export */   "Z": function() { return /* binding */ getBlogUrl; }
/* harmony export */ });
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9384);

var getOriginWithLocale = function(locale) {
    return "".concat(_utils__WEBPACK_IMPORTED_MODULE_0__/* .ORIGIN */ .jQ).concat(locale === "fr" ? "/fr" : "");
};
var getBlogUrl = function(param) {
    var locale = param.locale;
    return getOriginWithLocale(locale);
};
var getBlogPostingUrl = function(param) {
    var locale = param.locale, slug = param.slug;
    return "".concat(getOriginWithLocale(locale), "/post/").concat(slug);
};


/***/ }),

/***/ 6945:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "UL": function() { return /* binding */ useTina; }
/* harmony export */ });
/* unused harmony exports addMetadata, hashFromQuery, tinaField, useEditState */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

function useTina(props) {
  const stringifiedQuery = JSON.stringify({
    query: props.query,
    variables: props.variables
  });
  const id = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(
    () => hashFromQuery(stringifiedQuery),
    [stringifiedQuery]
  );
  const [data, setData] = react__WEBPACK_IMPORTED_MODULE_0__.useState(props.data);
  const [isClient, setIsClient] = react__WEBPACK_IMPORTED_MODULE_0__.useState(false);
  const [quickEditEnabled, setQuickEditEnabled] = react__WEBPACK_IMPORTED_MODULE_0__.useState(false);
  const [isInTinaIframe, setIsInTinaIframe] = react__WEBPACK_IMPORTED_MODULE_0__.useState(false);
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    setIsClient(true);
    setData(props.data);
  }, [id]);
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    if (quickEditEnabled) {
      let mouseDownHandler = function(e) {
        const attributeNames = e.target.getAttributeNames();
        const tinaAttribute = attributeNames.find(
          (name) => name.startsWith("data-tina-field")
        );
        let fieldName;
        if (tinaAttribute) {
          e.preventDefault();
          e.stopPropagation();
          fieldName = e.target.getAttribute(tinaAttribute);
        } else {
          const ancestor = e.target.closest(
            "[data-tina-field], [data-tina-field-overlay]"
          );
          if (ancestor) {
            const attributeNames2 = ancestor.getAttributeNames();
            const tinaAttribute2 = attributeNames2.find(
              (name) => name.startsWith("data-tina-field")
            );
            if (tinaAttribute2) {
              e.preventDefault();
              e.stopPropagation();
              fieldName = ancestor.getAttribute(tinaAttribute2);
            }
          }
        }
        if (fieldName) {
          if (isInTinaIframe) {
            parent.postMessage(
              { type: "field:selected", fieldName },
              window.location.origin
            );
          }
        }
      };
      const style = document.createElement("style");
      style.type = "text/css";
      style.textContent = `
        [data-tina-field] {
          outline: 2px dashed rgba(34,150,254,0.5);
          transition: box-shadow ease-out 150ms;
        }
        [data-tina-field]:hover {
          box-shadow: inset 100vi 100vh rgba(34,150,254,0.3);
          outline: 2px solid rgba(34,150,254,1);
          cursor: pointer;
        }
        [data-tina-field-overlay] {
          outline: 2px dashed rgba(34,150,254,0.5);
          position: relative;
        }
        [data-tina-field-overlay]:hover {
          cursor: pointer;
          outline: 2px solid rgba(34,150,254,1);
        }
        [data-tina-field-overlay]::after {
          content: '';
          position: absolute;
          inset: 0;
          z-index: 20;
          transition: opacity ease-out 150ms;
          background-color: rgba(34,150,254,0.3);
          opacity: 0;
        }
        [data-tina-field-overlay]:hover::after {
          opacity: 1;
        }
      `;
      document.head.appendChild(style);
      document.body.classList.add("__tina-quick-editing-enabled");
      document.addEventListener("click", mouseDownHandler, true);
      return () => {
        document.removeEventListener("click", mouseDownHandler, true);
        document.body.classList.remove("__tina-quick-editing-enabled");
        style.remove();
      };
    }
  }, [quickEditEnabled, isInTinaIframe]);
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    parent.postMessage({ type: "open", ...props, id }, window.location.origin);
    window.addEventListener("message", (event) => {
      if (event.data.type === "quickEditEnabled") {
        setQuickEditEnabled(event.data.value);
      }
      if (event.data.id === id && event.data.type === "updateData") {
        setData(event.data.data);
        setIsInTinaIframe(true);
        const anyTinaField = document.querySelector("[data-tina-field]");
        if (anyTinaField) {
          parent.postMessage(
            { type: "quick-edit", value: true },
            window.location.origin
          );
        } else {
          parent.postMessage(
            { type: "quick-edit", value: false },
            window.location.origin
          );
        }
      }
    });
    return () => {
      parent.postMessage({ type: "close", id }, window.location.origin);
    };
  }, [id, setQuickEditEnabled]);
  return { data, isClient };
}
function useEditState() {
  const [edit, setEdit] = React.useState(false);
  React.useEffect(() => {
    if (typeof window !== "undefined") {
      parent.postMessage({ type: "isEditMode" }, window.location.origin);
      window.addEventListener("message", (event) => {
        var _a;
        if (((_a = event.data) == null ? void 0 : _a.type) === "tina:editMode") {
          setEdit(true);
        }
      });
    }
  }, []);
  return { edit };
}
const tinaField = (object, property, index) => {
  var _a, _b, _c;
  if (!object) {
    return "";
  }
  if (object._content_source) {
    if (!property) {
      return [
        (_a = object._content_source) == null ? void 0 : _a.queryId,
        object._content_source.path.join(".")
      ].join("---");
    }
    if (typeof index === "number") {
      return [
        (_b = object._content_source) == null ? void 0 : _b.queryId,
        [...object._content_source.path, property, index].join(".")
      ].join("---");
    }
    return [
      (_c = object._content_source) == null ? void 0 : _c.queryId,
      [...object._content_source.path, property].join(".")
    ].join("---");
  }
  return "";
};
const addMetadata = (id, object, path) => {
  Object.entries(object).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((item, index) => {
        if (isScalarOrUndefined(item)) {
          return;
        }
        if (Array.isArray(item)) {
          return;
        }
        const itemObject = item;
        addMetadata(id, itemObject, [...path, key, index]);
      });
    } else {
      if (isScalarOrUndefined(value)) {
        return;
      }
      const itemObject = value;
      addMetadata(id, itemObject, [...path, key]);
    }
  });
  if ((object == null ? void 0 : object.type) === "root") {
    return;
  }
  object._content_source = {
    queryId: id,
    path
  };
  return object;
};
function isScalarOrUndefined(value) {
  const type = typeof value;
  if (type === "string")
    return true;
  if (type === "number")
    return true;
  if (type === "boolean")
    return true;
  if (type === "undefined")
    return true;
  if (value == null)
    return true;
  if (value instanceof String)
    return true;
  if (value instanceof Number)
    return true;
  if (value instanceof Boolean)
    return true;
  return false;
}
const hashFromQuery = (input) => {
  let hash = 0;
  for (let i = 0; i < input.length; i++) {
    const char = input.charCodeAt(i);
    hash = (hash << 5) - hash + char & 4294967295;
  }
  const nonNegativeHash = Math.abs(hash);
  const alphanumericHash = nonNegativeHash.toString(36);
  return alphanumericHash;
};



/***/ }),

/***/ 4626:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ TinaMarkdown; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

const TinaMarkdown = ({
  content,
  components = {}
}) => {
  if (!content) {
    return null;
  }
  const nodes = Array.isArray(content) ? content : content.children;
  if (!nodes) {
    return null;
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, nodes.map((child, index) => {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MemoNode, { components, key: index, child });
  }));
};
const Leaf = (props) => {
  if (props.bold) {
    const { bold, ...rest } = props;
    if (props.components.bold) {
      const Component = props.components.bold;
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, { ...rest }));
    }
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("strong", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, { ...rest }));
  }
  if (props.italic) {
    const { italic, ...rest } = props;
    if (props.components.italic) {
      const Component = props.components.italic;
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, { ...rest }));
    }
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("em", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, { ...rest }));
  }
  if (props.underline) {
    const { underline, ...rest } = props;
    if (props.components.underline) {
      const Component = props.components.underline;
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, { ...rest }));
    }
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("u", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, { ...rest }));
  }
  if (props.strikethrough) {
    const { strikethrough, ...rest } = props;
    if (props.components.strikethrough) {
      const Component = props.components.strikethrough;
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, { ...rest }));
    }
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("s", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, { ...rest }));
  }
  if (props.code) {
    const { code, ...rest } = props;
    if (props.components.code) {
      const Component = props.components.code;
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, { ...rest }));
    }
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("code", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, { ...rest }));
  }
  if (props.components.text) {
    const Component = props.components.text;
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, null, props.text);
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, props.text);
};
const MemoNode = (props) => {
  const MNode = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(
    () => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Node, { ...props }),
    [JSON.stringify(props)]
  );
  return MNode;
};
const Node = ({ components, child }) => {
  var _a, _b, _c, _d, _e, _f;
  const { children, ...props } = child;
  switch (child.type) {
    case "h1":
    case "h2":
    case "h3":
    case "h4":
    case "h5":
    case "h6":
    case "p":
    case "blockquote":
    case "ol":
    case "ul":
    case "li":
      if (components[child.type]) {
        const Component2 = components[child.type];
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component2, { ...props }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TinaMarkdown, { components, content: children }));
      }
      return react__WEBPACK_IMPORTED_MODULE_0__.createElement(child.type, {
        children: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TinaMarkdown, { components, content: children })
      });
    case "lic":
      if (components.lic) {
        const Component2 = components.lic;
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component2, { ...props }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TinaMarkdown, { components, content: children }));
      }
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TinaMarkdown, { components, content: child.children }));
    case "img":
      if (components[child.type]) {
        const Component2 = components[child.type];
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component2, { ...props });
      }
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", { src: child.url, alt: child.caption });
    case "a":
      if (components[child.type]) {
        const Component2 = components[child.type];
        return (
          // @ts-ignore FIXME: TinaMarkdownContent needs to be a union of all possible node types
          /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component2, { ...props }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TinaMarkdown, { components, content: children }))
        );
      }
      return (
        // @ts-ignore FIXME: TinaMarkdownContent needs to be a union of all possible node types
        /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", { href: child.url }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TinaMarkdown, { components, content: children }))
      );
    case "code_block":
      const value = child.value;
      if (components[child.type]) {
        const Component2 = components[child.type];
        return (
          // @ts-ignore FIXME: TinaMarkdownContent needs to be a union of all possible node types
          /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component2, { ...props })
        );
      }
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("pre", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("code", null, value));
    case "hr":
      if (components[child.type]) {
        const Component2 = components[child.type];
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component2, { ...props });
      }
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("hr", null);
    case "break":
      if (components[child.type]) {
        const Component2 = components[child.type];
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component2, { ...props });
      }
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("br", null);
    case "text":
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, { components, ...child });
    case "mdxJsxTextElement":
    case "mdxJsxFlowElement":
      const Component = components[child.name];
      if (Component) {
        const props2 = child.props ? child.props : {};
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, { ...props2 });
      } else {
        if (child.name === "table") {
          const firstRowHeader = (_a = child.props) == null ? void 0 : _a.firstRowHeader;
          const rows = (firstRowHeader ? (_b = child.props) == null ? void 0 : _b.tableRows.filter((_, i) => i !== 0) : (_c = child.props) == null ? void 0 : _c.tableRows) || [];
          const header = (_e = (_d = child.props) == null ? void 0 : _d.tableRows) == null ? void 0 : _e.at(0);
          const TableComponent = components["table"] || ((props2) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("table", { ...props2 }));
          const TrComponent = components["tr"] || ((props2) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("tr", { ...props2 }));
          const ThComponent = components["th"] || ((props2) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("th", { style: { textAlign: (props2 == null ? void 0 : props2.align) || "auto" }, ...props2 }));
          const TdComponent = components["td"] || ((props2) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("td", { style: { textAlign: (props2 == null ? void 0 : props2.align) || "auto" }, ...props2 }));
          const align = ((_f = child.props) == null ? void 0 : _f.align) || [];
          return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TableComponent, null, firstRowHeader && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("thead", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TrComponent, null, header.tableCells.map((c, i) => {
            return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
              TinaMarkdown,
              {
                key: i,
                components: {
                  p: (props2) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ThComponent, { align: align[i], ...props2 })
                },
                content: c.value
              }
            );
          }))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("tbody", null, rows.map((row, i) => {
            var _a2;
            return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TrComponent, { key: i }, (_a2 = row == null ? void 0 : row.tableCells) == null ? void 0 : _a2.map((c, i2) => {
              return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
                TinaMarkdown,
                {
                  key: i2,
                  components: {
                    p: (props2) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TdComponent, { align: align[i2], ...props2 })
                  },
                  content: c.value
                }
              );
            }));
          })));
        }
        const ComponentMissing = components["component_missing"];
        if (ComponentMissing) {
          return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ComponentMissing, { name: child.name });
        } else {
          return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, `No component provided for ${child.name}`);
        }
      }
    case "maybe_mdx":
      return null;
    case "html":
    case "html_inline":
      if (components[child.type]) {
        const Component2 = components[child.type];
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component2, { ...props });
      }
      return child.value;
    case "invalid_markdown":
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("pre", null, child.value);
    default:
      if (typeof child.text === "string") {
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, { components, ...child });
      }
  }
};



/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [94,487,774,888,179], function() { return __webpack_exec__(9212); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);